import axios from 'axios'
import { apiService, handleResponseData } from '../../../services/api.service'
import { CustomerCopilotSettings, CustomerCopilotSettingsRequest } from '../models/types'

function copilotUrl(customerId: string) {
  return apiService.getFullApiUrl(`/customer/${encodeURIComponent(customerId)}/copilot`)
}

// No .catch(handleApiException) here or below: its 500 is this endpoint's normal unreadable-key path
export function getCustomerCopilotSettings(customerId: string, signal?: AbortSignal) {
  return axios
    .get(copilotUrl(customerId), { signal })
    .then<CustomerCopilotSettings>(handleResponseData)
}

export function putCustomerCopilotSettings(
  customerId: string,
  request: CustomerCopilotSettingsRequest,
): Promise<void> {
  return axios.put(copilotUrl(customerId), request).then(() => undefined)
}
